<h2 mat-dialog-title>
  GL Journal
  <span class="muted-title">
    {{ data.type }} / {{ data.number }}
  </span>
</h2>

<mat-dialog-content
  class="transaction-detail-content"
  [class.gl-tag-dropdown-open]="tagDropdownOpen"
>
  <div class="header-section">
    <div class="header-grid">
      <div class="header-item">
        <div class="label">Period</div>
        <div class="value">
          {{ data.periodno }}
          <span *ngIf="data.periodname">- {{ data.periodname }}</span>
        </div>
      </div>
      <div class="header-item">
        <div class="label">Tran Date</div>
        <div class="value">
          {{ data.trandate | date }}
        </div>
      </div>
      <div class="header-item">
        <div class="label">Check #</div>
        <div class="value">
          {{ data.chequeno || '—' }}
        </div>
      </div>
      <div class="header-item header-item-span" *ngIf="data.debtorno || data.debtorname">
        <div class="label">Customer</div>
        <div class="value">
          <span *ngIf="data.debtorno">{{ data.debtorno }}</span>
          <span *ngIf="data.debtorno && data.debtorname"> — </span>
          <span *ngIf="data.debtorname">{{ data.debtorname }}</span>
        </div>
      </div>
      <div class="header-item" *ngIf="!editMode">
        <div class="label">Tag</div>
        <div class="value">
          {{ data.tag || '—' }}
        </div>
      </div>
    </div>
  </div>

  <div class="amounts-card">
    <table class="amounts-table">
      <thead>
        <tr>
          <th class="text-right">Debit</th>
          <th class="text-right">Credit</th>
          <th class="text-right">Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right amount">{{ data.debit | currency }}</td>
          <td class="text-right amount">{{ data.credit | currency }}</td>
          <td class="text-right amount">{{ data.balance | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="description-card" *ngIf="!editMode && data.narrative">
    <div class="label">Description</div>
    <div class="description-text">
      {{ data.narrative }}
    </div>
  </div>

  <div class="journal-card" *ngIf="journalLoading || journalError || journalLines.length">
    <div class="journal-header">
      <div class="label">Full GL Journal</div>
      <mat-spinner *ngIf="journalLoading" diameter="18"></mat-spinner>
    </div>
    <div *ngIf="!journalLoading && journalError" class="journal-error">
      {{ journalError }}
    </div>
    <div *ngIf="!journalLoading && journalLines.length" class="journal-table-wrap">
      <table class="journal-table">
        <thead>
          <tr>
            <th>Account</th>
            <th>Narrative</th>
            <th class="text-right">Debit</th>
            <th class="text-right">Credit</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of journalLines">
            <td class="journal-account">{{ line.accountcode }} - {{ line.accountname }}</td>
            <td>{{ line.narrative }}</td>
            <td class="text-right amount">{{ asNumber(line.debit) | number:'1.2-2' }}</td>
            <td class="text-right amount">{{ asNumber(line.credit) | number:'1.2-2' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2">Total</td>
            <td class="text-right amount">{{ journalTotalDebit | number:'1.2-2' }}</td>
            <td class="text-right amount">{{ journalTotalCredit | number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <div class="edit-form" *ngIf="editMode && data.counterindex != null">
    <form [formGroup]="editForm">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <input matInput formControlName="narrative" />
      </mat-form-field>
      <div class="gl-tag-field full-width" #tagRoot>
        <span class="gl-tag-label" id="gl-tag-field-label">Tag</span>
        <button
          type="button"
          class="gl-tag-trigger"
          #tagTriggerBtn
          (click)="toggleTagDropdown($event)"
          [attr.aria-expanded]="tagDropdownOpen"
          aria-haspopup="listbox"
          [attr.aria-labelledby]="'gl-tag-field-label'"
          [class.gl-tag-trigger-open]="tagDropdownOpen"
        >
          <span class="gl-tag-trigger-text">{{ tagSelectedLabel }}</span>
          <span class="gl-tag-chevron" aria-hidden="true"></span>
        </button>
        <div
          *ngIf="tagDropdownOpen"
          class="gl-tag-panel"
          role="listbox"
          [attr.aria-labelledby]="'gl-tag-field-label'"
          [ngStyle]="tagPanelStyle"
        >
          <button
            type="button"
            class="gl-tag-option"
            role="option"
            [attr.aria-selected]="isTagOptionActive(null)"
            [class.gl-tag-option-active]="isTagOptionActive(null)"
            (click)="selectTagRef(null)"
          >
            — None —
          </button>
          <button
            type="button"
            class="gl-tag-option"
            role="option"
            *ngFor="let t of tags"
            [attr.aria-selected]="isTagOptionActive(t.tagId)"
            [class.gl-tag-option-active]="isTagOptionActive(t.tagId)"
            (click)="selectTagRef(t.tagId)"
          >
            {{ t.description }}
          </button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" [class.gl-tag-actions-lower]="tagDropdownOpen">
  <button mat-stroked-button color="primary" (click)="close()">Close</button>
  <button mat-stroked-button *ngIf="canEdit && !editMode && data.counterindex != null" (click)="startEdit()">Edit</button>
  <ng-container *ngIf="editMode">
    <button mat-stroked-button (click)="cancelEdit()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="saving" (click)="save()">Save</button>
  </ng-container>
</mat-dialog-actions>

